module.exports = "@media only screen and (max-width: 560px) {\n  label {\n    margin-bottom: 2px !important;\n    margin-top: 2px !important; }\n  .form-control {\n    margin-bottom: 0px !important; }\n  .full-data-search {\n    margin-left: 0.0em  !important; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/magnetic-media/report-thirdparty-info/report-thirdparty-info.component.scss
// module id = ./src/app/modules/magnetic-media/report-thirdparty-info/report-thirdparty-info.component.scss
// module chunks = main